import { useMutation } from '@tanstack/react-query';
import { repo } from 'index';

export const useLicensePlateUpdate = () => {
  const { mutateAsync, status, isLoading } = useMutation({
    mutationFn: repo.updateLicensePlate,
  });

  return {
    updateLicensePlateMutateAsync: mutateAsync,
    updateLicensePlateStatus: status,
    isUpdateLicensePlateLoading: isLoading,
  };
};
